import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-3xl mx-auto text-gray-900 dark:text-gray-100">
      <Helmet>
        <title>Terms & Conditions - Imagera</title>
        <meta
          name="description"
          content="These terms and conditions govern your use of Imagera. Read about your rights, responsibilities, and the rules of our platform."
        />
      </Helmet>

      <button
        onClick={() => navigate('/')}
        className="mb-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        aria-label="Back to Home"
      >
        ← Back to Home
      </button>

      <h1 className="text-4xl font-extrabold mb-8">Terms & Conditions</h1>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
        <p>
          Welcome to <strong>Imagera</strong>. By accessing or using our platform, you agree to comply with these Terms & Conditions. If you do not agree, please do not use the service.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">2. Eligibility</h2>
        <p>
          You must be at least 13 years old to use Imagera. By using this service, you confirm that you meet this requirement and are capable of entering a binding agreement.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">3. User Responsibilities</h2>
        <p>
          You agree not to:
        </p>
        <ul className="list-disc list-inside space-y-2">
          <li>Violate any laws or post illegal content</li>
          <li>Harass, abuse, or harm others</li>
          <li>Upload viruses or malicious software</li>
          <li>Use the platform to impersonate others</li>
        </ul>
        <p>
          Violations may result in account suspension or permanent ban.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">4. Content Ownership</h2>
        <p>
          You retain ownership of the content you post. However, by uploading content, you grant Imagera a non-exclusive, royalty-free license to display, share, and promote it on the platform.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">5. Coins and Redemption</h2>
        <p>
          Coins are earned through user interactions (likes) and can be redeemed as per our policies. Any attempt to manipulate coin earning (e.g., using fake accounts) will result in disqualification and potential account termination.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">6. Third-party Services</h2>
        <p>
          Imagera integrates services like EmailJS, Google AdSense, and analytics tools. These services may collect user data as per their own privacy policies. We are not responsible for their practices.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">7. Limitation of Liability</h2>
        <p>
          Imagera is provided "as is." We are not liable for damages, losses, or interruptions caused by using the platform.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">8. Changes to Terms</h2>
        <p>
          We may update these terms from time to time. Continued use of the platform after updates constitutes acceptance of the new terms.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-3">9. Contact Us</h2>
        <p>
          For any questions or disputes related to these Terms & Conditions, please contact us at:
          <br />
          <a href="mailto:hitarth0236@gmail.com" className="text-blue-600 underline">hitarth0236@gmail.com</a>
        </p>
      </section>

      <p className="text-sm text-gray-600 dark:text-gray-400">
        Last updated: June 2025
      </p>
    </div>
  );
};

export default Terms;